var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1752116195223,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1806,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M966.940444 685.226667c-31.402667 0-56.945778-28.785778-56.945777-64.227556V406.869333c0-35.498667 25.543111-64.227556 56.888889-64.227555 31.516444 0 56.888889 28.728889 56.888888 64.227555v214.129778c0 35.441778-25.372444 64.227556-56.888888 64.227556z m-226.417777 115.768889c-31.004444 0-56.206222-27.420444-56.206223-61.269334V290.929778c0-33.792 25.201778-61.212444 56.206223-61.212445 31.118222 0 56.263111 27.420444 56.263111 61.212445v448.796444c0 33.848889-25.144889 61.269333-56.32 61.269334z m-227.726223 165.944888a54.840889 54.840889 0 0 1-55.182222-54.613333V111.331556c0-30.151111 24.746667-54.556444 55.182222-54.556445 30.435556 0 55.125333 24.405333 55.125334 54.556445v800.995555c0 30.208-24.689778 54.613333-55.125334 54.613333zM285.696 799.800889c-31.402667 0-56.888889-27.420444-56.888889-61.155556V290.702222c0-33.792 25.486222-61.155556 56.888889-61.155555S342.584889 256.910222 342.584889 290.702222v447.943111c0 33.735111-25.543111 61.155556-56.945778 61.155556z m-228.807111-113.777778c-31.459556 0-56.945778-28.785778-56.945778-64.341333V407.381333c0-35.555556 25.486222-64.284444 56.888889-64.284444 31.459556 0 56.945778 28.728889 56.945778 64.284444v214.300445c0 35.555556-25.486222 64.341333-56.888889 64.341333z",
    fill: "#666666",
    "p-id": 1807
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.8db1e5ec981fe58fe5a224dc541df6cf.svg";
export { ForwardRef as ReactComponent };